import React from "react";

import { useNavigate } from "react-router-dom";

import useDecodedParams from "Hooks/useDecodedParams";

import EnvironmentSyncPane from "./containers/EnvironmentSyncPane";

type EnvironmentActionsSyncProps = {
  isSizingApiEnabled?: boolean;
};

const EnvironmentActionsSync = (props: EnvironmentActionsSyncProps) => {
  const navigate = useNavigate();
  const params = useDecodedParams<{
    organizationId: string;
    projectId: string;
    environmentId: string;
  }>();
  return <EnvironmentSyncPane push={navigate} {...params} {...props} />;
};

export default EnvironmentActionsSync;
